import React from 'react';
import {Route, Routes} from 'react-router-dom';
import WebComponentEntry from '../pages/WebComponentEntry/WebComponentEntry';
import {sharedRoutes} from './sharedRoutes';

function PrequalRoutesWC(props) {
  return (
    <Routes>
      <Route
        path='/'
        element={
          <div className='prequal--web--form-container'>
            <WebComponentEntry {...props} />
          </div>
        }
      />
      {sharedRoutes(props)}
    </Routes>
  );
}

export default PrequalRoutesWC;
